export default __webpack_public_path__ + "static/repatalk-12-b37c34fd86d1b20e35da09dccfc23be3.webp";